import React, { useMemo } from 'react';
// import { useStore } from '@tanstack/react-form'; // KALDIRILDI
import { Box, Grid, Paper } from '@material-ui/core';
import { Add, DeveloperBoard, Done } from '@material-ui/icons';
import { DefectList } from './DefectList';
import { BadgeButton } from './Buttons';
import { useDefectDialogHandlers } from './Defect.hooks';
import { Cost } from '../components/Cost';

function useFormValues(form, selector) {
  const [sel, setSel] = React.useState(() => selector(form.values));
  React.useEffect(() => {
    const unsub = form.subscribe(() => setSel(selector(form.values)));
    return unsub;
  }, [form, selector]);
  return sel;
}

export function Defect({ form, user }) {
    const currency = user.CurrencyUnit;
    const tanentCode = user.TenantCode;

    const {
        Defects,
        WorkOrderDetails,
        WorkOrderLabours,
        WorkOrderMaterials,
        WorkOrderTransport,
        WorkOrderExtra
    } = useFormValues(form, v => ({
      Defects: v.Defects || [],
      WorkOrderDetails: v.WorkOrderDetails || [],
      WorkOrderLabours: v.WorkOrderLabours || [],
      WorkOrderMaterials: v.WorkOrderMaterials || [],
      WorkOrderTransport: v.WorkOrderTransport || [],
      WorkOrderExtra: v.WorkOrderExtra || []
    }));

    const {
        handleAddLabour,
        handleAddMaterial,
        handleDeleteLabour,
        handleDeleteMaterial,
        handleAddDefect,
        handleAddTransport,
        handleShowMaterialStocks
    } = useDefectDialogHandlers({
        form,
        currency,
        tanentCode
    });

    const defectListData = useMemo(() => {
        return WorkOrderDetails.map(item => ({
            ...item,
            userCode: Defects.find(d => d.Code === item.DefectId)?.UserCode,
            labours: WorkOrderLabours.filter(l => l.DefectId === item.DefectId),
            materials: WorkOrderMaterials.filter(m => m.DefectId === item.DefectId)
        }));
    }, [Defects, WorkOrderDetails, WorkOrderLabours, WorkOrderMaterials]);

    return (
        <Paper>
            <Box px={2} py={1} mb={1}>
                <Grid container justifyContent="space-between">
                    <Grid item>
                        <BadgeButton main="D" content={<Add />} onClick={handleAddDefect} />
                    </Grid>
                    <Grid item>
                        <Grid container spacing={1}>
                            <Grid item>
                                <BadgeButton disabled main="T" content={<Add />} onClick={handleAddTransport} />
                            </Grid>
                            <Grid item>
                                <BadgeButton
                                    disabled
                                    main={<DeveloperBoard />}
                                    content={<Done />}
                                    onClick={handleShowMaterialStocks}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
            <Box px={2} pb={2}>
                <DefectList
                    data={defectListData}
                    currency={currency}
                    tanentCode={tanentCode}
                    onAddLabour={handleAddLabour}
                    onAddMaterial={handleAddMaterial}
                    onDeleteLabour={handleDeleteLabour}
                    onDeleteMaterial={handleDeleteMaterial}
                />
            </Box>
            <Box px={2} pb={2}>
                <Cost
                    currency={currency}
                    tenantCode={tanentCode}
                    workOrderLabours={WorkOrderLabours}
                    workOrderMaterials={WorkOrderMaterials}
                    workOrderTransport={WorkOrderTransport}
                    workOrderExtra={WorkOrderExtra}
                />
            </Box>
        </Paper>
    );
}
